Given the we are good at: {{goodAt}}.
Passionate about {{passionateAbout}}.
Our customers need {{customerNeed}}.
We can getting paid from {{getPaidFor}}.
Generate a bullseye statement for the organisation with not more than {{maxLength}} characters. Please do not include character count in
the response message.
